import React from 'react';

import {
  AutoMode,
  Autorenew,
  CheckCircleOutline,
  CircleOutlined,
  DangerousOutlined,
  HelpOutlineOutlined,
  PauseCircleOutline,
  PendingOutlined,
  PublishedWithChanges,
  SyncDisabled,
  WarningAmberOutlined,
} from '@mui/icons-material';

import { SvgIcon } from '@mui/material';

const ErrorOutlinedCustom = (props) => (
  <SvgIcon viewBox="0 0 15 16" {...props}>
    <path d="M7.5 11.9512C7.7125 11.9512 7.89075 11.8792 8.03475 11.7352C8.17825 11.5917 8.25 11.4137 8.25 11.2012C8.25 10.9887 8.17825 10.8104 8.03475 10.6664C7.89075 10.5229 7.7125 10.4512 7.5 10.4512C7.2875 10.4512 7.1095 10.5229 6.966 10.6664C6.822 10.8104 6.75 10.9887 6.75 11.2012C6.75 11.4137 6.822 11.5917 6.966 11.7352C7.1095 11.8792 7.2875 11.9512 7.5 11.9512ZM6.75 8.95117H8.25V4.45117H6.75V8.95117ZM7.5 15.7012C6.4625 15.7012 5.4875 15.5042 4.575 15.1102C3.6625 14.7167 2.86875 14.1824 2.19375 13.5074C1.51875 12.8324 0.9845 12.0387 0.591 11.1262C0.197 10.2137 0 9.23867 0 8.20117C0 7.16367 0.197 6.18867 0.591 5.27617C0.9845 4.36367 1.51875 3.56992 2.19375 2.89492C2.86875 2.21992 3.6625 1.68542 4.575 1.29142C5.4875 0.897922 6.4625 0.701172 7.5 0.701172C8.5375 0.701172 9.5125 0.897922 10.425 1.29142C11.3375 1.68542 12.1313 2.21992 12.8063 2.89492C13.4813 3.56992 14.0155 4.36367 14.409 5.27617C14.803 6.18867 15 7.16367 15 8.20117C15 9.23867 14.803 10.2137 14.409 11.1262C14.0155 12.0387 13.4813 12.8324 12.8063 13.5074C12.1313 14.1824 11.3375 14.7167 10.425 15.1102C9.5125 15.5042 8.5375 15.7012 7.5 15.7012ZM7.5 14.2012C9.175 14.2012 10.5937 13.6199 11.7562 12.4574C12.9187 11.2949 13.5 9.87617 13.5 8.20117C13.5 6.52617 12.9187 5.10742 11.7562 3.94492C10.5937 2.78242 9.175 2.20117 7.5 2.20117C5.825 2.20117 4.40625 2.78242 3.24375 3.94492C2.08125 5.10742 1.5 6.52617 1.5 8.20117C1.5 9.87617 2.08125 11.2949 3.24375 12.4574C4.40625 13.6199 5.825 14.2012 7.5 14.2012Z" />
  </SvgIcon>
);

export const DEFAULT_STATUS_INFO = {
  icon: <HelpOutlineOutlined fontSize="inherit" className="dn-inactive" />,
  severity: 'warning',
};

export const DEFAULT_STATUS_INFO_LIST = {
  SUCCESS: {
    status: 'Active',
    icon: <CheckCircleOutline className="dn-success" fontSize="inherit" />,
    title: 'Available',
    severity: 'success',
  },
  INACTIVE: {
    status: 'Inactive',
    icon: <PauseCircleOutline className="dn-inactive" fontSize="inherit" />,
    title: 'Inactive',
    severity: 'info',
  },
  BLOCKED: {
    status: 'Blocked',
    icon: <DangerousOutlined className="dn-blocked-status" fontSize="inherit" />,
    title: 'Blocked',
    severity: 'error',
  },
  FAIL: {
    status: 'Fail',
    icon: <DangerousOutlined className="dn-not-connected" fontSize="inherit" />,
    title: 'Fail',
    severity: 'error',
  },
  PENDING: {
    status: 'Pending',
    icon: <PendingOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Pending',
    severity: 'warning',
  },
  PENDING_EMPTY: {
    status: 'Pending',
    icon: <CircleOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Pending',
    severity: 'warning',
  },
  EXPIRED: {
    status: 'Pending',
    icon: <WarningAmberOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Expired',
    severity: 'warning',
  },
  APPLICATION_EXPIRED: {
    status: 'Pending',
    icon: <WarningAmberOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Application expired',
    severity: 'warning',
  },
  UNAUTHORIZED: {
    status: 'Unauthorized',
    icon: <ErrorOutlinedCustom fontSize="inherit" className="dn-unauthorized" />,
    title: 'Unauthorized',
    severity: 'warning',
  },
  UP_TO_DATE_YES: {
    status: 'Active',
    icon: <CheckCircleOutline className="dn-success" fontSize="inherit" />,
    title: 'UP_TO_DATE_YES',
    text: 'UP_TO_DATE_YES',
    severity: 'success',
  },
  UP_TO_DATE_NO: {
    status: 'Pending',
    icon: <SyncDisabled className="dn-pending" fontSize="inherit" />,
    title: 'UP_TO_DATE_NO',
    text: 'UP_TO_DATE_NO',
    severity: 'warning',
  },
};

export const REPORT_STATUS_INFO_LIST = {
  ...DEFAULT_STATUS_INFO_LIST,
  NO_ROWS: {
    icon: <CircleOutlined fontSize="inherit" className="dn-inactive" />,
    title: 'No results',
    severity: 'warning',
  },
};

export const TRANSACTION_UPLOADS_STATUS_INFO_LIST = {
  PENDING: {
    status: 'Pending',
    icon: <AutoMode fontSize="inherit" className="dn-pending" />,
    title: 'Pending',
    severity: 'warning',
  },
  IN_PROGRESS: {
    status: 'Processing',
    icon: <Autorenew fontSize="inherit" className="dn-pending" />,
    title: 'Processing',
    severity: 'info',
  },
  COMPLETED: {
    status: 'Active',
    icon: <PublishedWithChanges fontSize="inherit" className="dn-success" />,
    title: 'Completed',
    text: 'Completed',
    severity: 'success',
  },
  FAIL: {
    status: 'Fail',
    icon: <SyncDisabled fontSize="inherit" className="dn-not-connected" />,
    title: 'Fail',
    severity: 'error',
  },
  FAILED: {
    status: 'Fail',
    icon: <SyncDisabled fontSize="inherit" className="dn-not-connected" />,
    title: 'Fail',
    severity: 'error',
  },
  PARTIAL_ERROR: {
    status: 'Partial errors',
    icon: <SyncDisabled fontSize="inherit" className="dn-not-connected" />,
    title: 'Partial errors',
    severity: 'error',
  },
  UNSUPPORTED_FILE: {
    status: 'Unsupported file',
    icon: <SyncDisabled fontSize="inherit" className="dn-not-connected" />,
    title: 'Unsupported file',
    severity: 'error',
  },
};

export const USERS_STATUS_INFO_LIST = {
  ACTIVE: {
    status: 'Active',
    icon: <CheckCircleOutline className="dn-success" fontSize="inherit" />,
    title: 'Active',
    severity: 'success',
  },
  AVAILABLE: {
    status: 'Active',
    icon: <CheckCircleOutline className="dn-success" fontSize="inherit" />,
    title: 'Available',
    severity: 'success',
  },
  INACTIVE: {
    status: 'Inactive',
    icon: <PauseCircleOutline className="dn-inactive" fontSize="inherit" />,
    title: 'Inactive',
    severity: 'info',
  },
  BLOCKED: {
    status: 'User blocked',
    icon: <DangerousOutlined className="dn-blocked-status" fontSize="inherit" />,
    title: 'User blocked',
    severity: 'error',
  },
  AUTO_DELETED: {
    status: 'Deleted',
    icon: <DangerousOutlined className="dn-blocked-status" fontSize="inherit" />,
    title: 'This account was deleted by the institution.',
    severity: 'error',
  },
  FAIL: {
    status: 'Not connected',
    icon: <DangerousOutlined className="dn-not-connected" fontSize="inherit" />,
    title: 'We couldn\'t process this Link.',
    severity: 'error',
  },
  UNAUTHORIZED: {
    status: 'Unauthorized',
    icon: <ErrorOutlinedCustom fontSize="inherit" className="dn-unauthorized" />,
    title: 'Invalid credentials',
    severity: 'warning',
  },
  PARTIALLY_REGISTERED: {
    status: 'Partially',
    icon: <CircleOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Partially registered',
    severity: 'warning',
  },
  PENDING: {
    status: 'Pending',
    icon: <CircleOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Pending',
    severity: 'warning',
  },
  PENDING_CONFIRMATION: {
    status: 'Pending',
    icon: <CircleOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Pending confirmation',
    severity: 'warning',
  },
  PENDING_INVITATION: {
    status: 'Pending',
    icon: <CircleOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Pending invitation',
    severity: 'warning',
  },
  UPDATING_TRANSACTIONS: {
    status: 'Processing',
    icon: <PendingOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Processing Transactions',
    severity: 'warning',
  },
  UPDATING_ASSETS: {
    status: 'Processing',
    icon: <PendingOutlined fontSize="inherit" className="dn-pending" />,
    title: 'Processing Accounts',
    severity: 'warning',
  },
  PENDING_DEVICE_REGISTRATION: {
    status: 'Device registration',
    icon: <CircleOutlined fontSize="inherit" className="dn-pending" />,
    title: 'An admin/master user must approve the registration of the device',
    severity: 'warning',
  },
};
